/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AorvExcelZeile } from './AorvExcelZeile';
import {
    AorvExcelZeileFromJSON,
    AorvExcelZeileFromJSONTyped,
    AorvExcelZeileToJSON,
} from './AorvExcelZeile';

/**
 * AORV-Import-Datensatz
 * @export
 * @interface AorvImport
 */
export interface AorvImport {
    /**
     * 
     * @type {number}
     * @memberof AorvImport
     */
    id?: number;
    /**
     * Benutzer-ID vom erstellten Import
     * @type {string}
     * @memberof AorvImport
     */
    erstelltVon: string;
    /**
     * Zeitstempel, wann der Import übertragen wurde
     * @type {string}
     * @memberof AorvImport
     */
    erstelltAm: string;
    /**
     * Jahr, für das der Import durchgeführt wurde
     * @type {number}
     * @memberof AorvImport
     */
    jahr: number;
    /**
     * 
     * @type {number}
     * @memberof AorvImport
     */
    kostenSchaetzungGesamt: number;
    /**
     * 
     * @type {number}
     * @memberof AorvImport
     */
    rechnungsBetragGesamt: number;
    /**
     * 
     * @type {Array<AorvExcelZeile>}
     * @memberof AorvImport
     */
    aorvExcelZeilen: Array<AorvExcelZeile>;
}

/**
 * Check if a given object implements the AorvImport interface.
 */
export function instanceOfAorvImport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "erstelltVon" in value;
    isInstance = isInstance && "erstelltAm" in value;
    isInstance = isInstance && "jahr" in value;
    isInstance = isInstance && "kostenSchaetzungGesamt" in value;
    isInstance = isInstance && "rechnungsBetragGesamt" in value;
    isInstance = isInstance && "aorvExcelZeilen" in value;

    return isInstance;
}

export function AorvImportFromJSON(json: any): AorvImport {
    return AorvImportFromJSONTyped(json, false);
}

export function AorvImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvImport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'erstelltVon': json['erstelltVon'],
        'erstelltAm': json['erstelltAm'],
        'jahr': json['jahr'],
        'kostenSchaetzungGesamt': json['kostenSchaetzungGesamt'],
        'rechnungsBetragGesamt': json['rechnungsBetragGesamt'],
        'aorvExcelZeilen': ((json['aorvExcelZeilen'] as Array<any>).map(AorvExcelZeileFromJSON)),
    };
}

export function AorvImportToJSON(value?: AorvImport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'erstelltVon': value.erstelltVon,
        'erstelltAm': value.erstelltAm,
        'jahr': value.jahr,
        'kostenSchaetzungGesamt': value.kostenSchaetzungGesamt,
        'rechnungsBetragGesamt': value.rechnungsBetragGesamt,
        'aorvExcelZeilen': ((value.aorvExcelZeilen as Array<any>).map(AorvExcelZeileToJSON)),
    };
}

